import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const availableModalState = ['none', 'writable'] as const;
export type ModalState = (typeof availableModalState)[number];

type InitialState = {
  modalState: ModalState;
};

const initialState: InitialState = {
  modalState: 'none',
};

export const generateIbanSlice = createSlice({
  name: 'generateIbanSlice',
  initialState,
  reducers: {
    setGenerateIbanModalState: (state, { payload }: PayloadAction<ModalState>) => {
      state.modalState = payload;
    },
    closeGenerateIbanModal: (state) => {
      state.modalState = 'none';
    },
  },
  selectors: {
    selectGenerateIbanModalState: (state) => state.modalState,
  },
});

export const { closeGenerateIbanModal, setGenerateIbanModalState } = generateIbanSlice.actions;
export const { selectGenerateIbanModalState } = generateIbanSlice.selectors;
